import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* 1. 重置默认样式 + 全局字体 */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html,
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    color: #333333; /* 全局文字颜色：深灰色，适合企业站 */
    background-color: #ffffff; /* 全局背景：白色，企业官网标准背景 */
    line-height: 1.6;
  }

  /* 2. 全局链接样式 */
  a {
    color: inherit; /* 继承父元素颜色，避免默认蓝色 */
    text-decoration: none;
  }

  /* 3. 标题全局样式 */
  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    margin-bottom: 1rem;
  }

  /* 4. 企业官网核心样式（模仿 Wisdom 风格） */
  
  /* 全局容器：控制内容宽度，让页面居中 */
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  /* 页面通用内边距：给所有页面上下留空间 */
  .page-section {
    padding: 4rem 0;
  }

  /* 5. 品牌色定义（对应 Wisdom 的蓝色+红色） */
  :root {
    --color-primary: #0099ff; /* Wisdom 同款蓝色：导航栏、按钮、主链接 */
    --color-secondary: #ff0000; /* 红色：Logo、强调色（如价格、促销） */
    --color-text: #333333;      /* 正文文字深灰 */
    --color-text-light: #666666; /* 辅助文字浅灰 */
  }

  /* 6. 通用按钮样式 */
  .btn {
    display: inline-block;
    padding: 0.8rem 1.5rem;
    background-color: var(--color-primary);
    color: white;
    border: none;
    border-radius: 4px;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.3s;
  }

  .btn:hover {
    opacity: 0.8;
  }

  /* 7. 卡片通用样式（产品页、案例页用） */
  .card {
    background: white;
    border: 1px solid #eaeaea;
    border-radius: 8px;
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.3s;
  }

  .card:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }
`;

export default GlobalStyle;